// import axios from 'axios';
import { API, Auth } from 'aws-amplify';
import React from 'react';
import { useHistory } from 'react-router-dom';
import * as JsStore from 'jsstore';
import {
  parse,
  isValid,
  parseISO,
  intervalToDuration,
  isToday,
  differenceInCalendarDays,
  format,
} from 'date-fns';
import { IAggFuncParams, ValueGetterParams } from 'ag-grid-community';
import { IAdvanceFilterEngine, IAdvanceFilterEngineRes, IFiltersApplied } from '../types/IFilterEngine';
import { formatString } from '../ApiMapping';

//declare const JsStore: any;
declare const ldb: any;

const dbConnection = new JsStore.Connection(new Worker('/jsstore.worker.js'));

export const apiName = 'tenantSpecificEndpoint';

const config = {
  "business_address": "150 Executive Drive, Suite Q, Edgewood, NY 11717",
  "business_address_1": "150 Executive Drive",
  "business_address_2": "Suite Q",
  "business_address_3": "Edgewood, NY 11717",
  "business_buyer_site": "https://dev-buyer-saas.phonexcorp.com",
  "business_copyrights_text": "© 2021 We Sell Cellular. All rights reserved.",
  "business_phone": "+1 (516) 334-6400",
  "business_tenant_site": "https://dev-tenant-saas.phonexcorp.com",
  "business_website": "https://www.wesellcellular.com",
  "CSS::px_alpha_darker": "0.63",
  "CSS::px_alpha_darker::phonex_theme_variant": "0.63",
  "CSS::px_alpha_light": "0.1",
  "CSS::px_alpha_light::phonex_theme_variant": "0.1",
  "CSS::px_alpha_lighter": "0.03",
  "CSS::px_alpha_lighter::phonex_theme_variant": "0.03",
  "CSS::px_alpha_medium": "0.4",
  "CSS::px_alpha_medium::phonex_theme_variant": "0.4",
  "CSS::px_alpha_muted": "0.33",
  "CSS::px_alpha_muted::phonex_theme_variant": "0.33",
  "CSS::px_color_background": "#FFFFFF",
  "CSS::px_color_background::phonex_theme_variant": "#F8F8F8",
  "CSS::px_color_badge_1": "#DBA200",
  "CSS::px_color_badge_1::phonex_theme_variant": "#BE5700",
  "CSS::px_color_badge_1b": "#DBA200",
  "CSS::px_color_badge_1b::phonex_theme_variant": "#DBA200",
  "CSS::px_color_badge_2": "#5A8B30",
  "CSS::px_color_badge_2::phonex_theme_variant": "#5A8B30",
  "CSS::px_color_badge_2b": "#5A8B30",
  "CSS::px_color_badge_2b::phonex_theme_variant": "#5A8B30",
  "CSS::px_color_badge_3": "#2F50AC",
  "CSS::px_color_badge_3::phonex_theme_variant": "#2F50AC",
  "CSS::px_color_badge_3b": "#2F50AC",
  "CSS::px_color_badge_3b::phonex_theme_variant": "#2F50AC",
  "CSS::px_color_badge_4": "#8A3AE5",
  "CSS::px_color_badge_4::phonex_theme_variant": "#8A3AE5",
  "CSS::px_color_badge_5": "#D21EA9",
  "CSS::px_color_badge_5::phonex_theme_variant": "#D21EA9",
  "CSS::px_color_badge_6": "#816C6C",
  "CSS::px_color_badge_6::phonex_theme_variant": "#816C6C",
  "CSS::px_color_border": "#d3d3d3",
  "CSS::px_color_border::phonex_theme_variant": "#d3d3d3",
  "CSS::px_color_border_light": "#e5e5e5",
  "CSS::px_color_border_light::phonex_theme_variant": "#e5e5e5",
  "CSS::px_color_error": "#D32F2F",
  "CSS::px_color_error::phonex_theme_variant": "#D32F2F",
  "CSS::px_color_error_input": "#D32F2F",
  "CSS::px_color_error_input::phonex_theme_variant": "#D32F2F",
  "CSS::px_color_error_text": "#D32F2F",
  "CSS::px_color_error_text::phonex_theme_variant": "#D32F2F",
  "CSS::px_color_info": "#202020",
  "CSS::px_color_info::phonex_theme_variant": "#202020",
  "CSS::px_color_link": "#124191",
  "CSS::px_color_link::phonex_theme_variant": "#124191",
  "CSS::px_color_link_active": "#124191",
  "CSS::px_color_link_active::phonex_theme_variant": "#124191",
  "CSS::px_color_link_hover": "#113167",
  "CSS::px_color_link_hover::phonex_theme_variant": "#113167",
  "CSS::px_color_link_visited": "#124191",
  "CSS::px_color_link_visited::phonex_theme_variant": "#124191",
  "CSS::px_color_primary": "#50A1FF",
  "CSS::px_color_primary::phonex_theme_variant": "#50A1FF",
  "CSS::px_color_secondary": "#FFF492",
  "CSS::px_color_secondary::phonex_theme_variant": "#FFF492",
  "CSS::px_color_success": "#4CAF50",
  "CSS::px_color_success::phonex_theme_variant": "#4CAF50",
  "CSS::px_color_surface": "#FFFFFF",
  "CSS::px_color_surface::phonex_theme_variant": "#FFFFFF",
  "CSS::px_color_text_muted": "#BBBBBB",
  "CSS::px_color_text_muted::phonex_theme_variant": "#BBBBBB",
  "CSS::px_color_text_on_badge": "#FFFFFF",
  "CSS::px_color_text_on_badge::phonex_theme_variant": "#FFFFFF",
  "CSS::px_color_text_on_primary": "#FFFFFF",
  "CSS::px_color_text_on_primary::phonex_theme_variant": "#FFFFFF",
  "CSS::px_color_text_on_secondary": "#8A8A8A",
  "CSS::px_color_text_on_secondary::phonex_theme_variant": "#8A8A8A",
  "CSS::px_color_text_on_snackbar": "#FFFFFF",
  "CSS::px_color_text_on_snackbar::phonex_theme_variant": "#FFFFFF",
  "CSS::px_color_text_primary": "#212121",
  "CSS::px_color_text_primary::phonex_theme_variant": "#212121",
  "CSS::px_color_text_secondary": "#757575",
  "CSS::px_color_text_secondary::phonex_theme_variant": "#757575",
  "CSS::px_color_text_variant": "#2974CC",
  "CSS::px_color_text_variant::phonex_theme_variant": "#2974CC",
  "CSS::px_color_warning": "#F57C00",
  "CSS::px_color_warning::phonex_theme_variant": "#F57C00",
  "CSS::px_font_body": "'Roboto', sans-serif",
  "CSS::px_font_body::phonex_theme_variant": "'Roboto', sans-serif",
  "CSS::px_font_title": "'Roboto', sans-serif",
  "CSS::px_font_title::phonex_theme_variant": "'Roboto', sans-serif",
  "CSS::px_topLogoHeight": "50px",
  "CSS::px_topLogoHeight::phonex_theme_variant": "50px",
  "CSS::px_topLogoWidth": "100px",
  "CSS::px_topLogoWidth::phonex_theme_variant": "100px",
  "descriptionParts": "{ \"Accessories\": \"\", \"Hearables\": \"\", \"Other\": \"\", \"Phones\": \"warehouse,manufacturer,model,model_number,capacity,protocol,grade,lock_status\", \"Tablet\": \"\", \"Wearables\": \"\" }",
  "favicon": "data:image/png;base64,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",
  "gradeScaleUrl": null,
  "groupAttributes": "manufacturer,model,warehouse,grade,capacity",
  "groupDescription": "manufacturer,model,capacity,grade",
  "language": "en-US",
  "logoSmall": "data:image/png;base64,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",
  "region": "us-east-1",
  "siteDescription": "PhoneX SaaS Admin",
  "siteTitle": "PhoneX-Admin",
  "tenantApiEndPoint": process.env.REACT_APP_ADMIN_API || 'https://7aw3yxmw73.execute-api.us-east-1.amazonaws.com/Integration', //"https://74s3piukt0.execute-api.us-east-1.amazonaws.com",
  "tenantApiName": "tenantSpecificEndpoint",
  "tenantName": "PhoneX-Admin",
  "tenantShortName": "WSC",
  "tenant_id": "T01",
  "termsOfSaleUrl": "https://www.wesellcellular.com/policy/terms-of-service/",
  "userPoolId": process.env.REACT_APP_USER_POOL_ID || 'us-east-1_L79AIIFtK', //"us-east-1_3KowSPTnr",
  "userPoolLogo": "data:image/png;base64,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",
  "userPoolWebClientId": process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || '4nm8pi16jrbdthlpsspmc3o9vp',
  "user_invitation_template": "tem_pfjCPBHPrJRBYCC9PygfpGgS",
  "user_verification_template": "tem_VJCxdHtTTRpktgf4PP3btH9S"
};

const i18n = {"en-US":{"placeholder":{"i18n_value":"placeholder","i18n_value_plural":null,"i18n_value_male":null,"i18n_value_female":null}}};

const lang = 'en-US';

const extraParams = {
  headers: {
    // "pxTestAPIHeader": "pxTestAPIHeaderVal"
  },
};

export const getConfig = () => {
  return new Promise((resolve: any) => {
    const localConfig = localStorage.getItem('PxConfig');
    if (!localConfig) {
      localStorage.setItem('PxConfig', JSON.stringify(config));
    }
    resolve(config);
    // const localConfig = localStorage.getItem('PxConfig');
    // if (localConfig && Object.keys(JSON.parse(localConfig)).length > 0) {
    //   resolve(JSON.parse(localConfig));
    // } else {
    //   let publicDataEndpoint =
    //     'https://l2dqqbs9r2.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-config';
    //   if (process.env.REACT_APP_STAGE === 'test') {
    //     publicDataEndpoint =
    //       'https://s4z4motqq3.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-config';
    //   } else if (process.env.REACT_APP_STAGE === 'prod') {
    //     publicDataEndpoint =
    //       'https://qkexusfqqf.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-config';
    //   } else if (process.env.REACT_APP_STAGE === 'release') {
    //     publicDataEndpoint =
    //       'https://94o107xk88.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-config';
    //   }
    //   axios.get(publicDataEndpoint).then(async (res: any) => {
    //     // TODO: check if getting correct config or not
    //     if (res.data.status === 200) {
    //       localStorage.setItem('PxConfig', JSON.stringify(res.data.results));
    //       resolve(res.data.results);
    //     } else {
    //       resolve({});
    //     }
    //   });
    // }
  });
};

const getDbSchema = () => {
  const inventoryTb = {
    name: 'InventoryTb',
    columns: {
      item_number_warehouse: { notNull: true, dataType: 'string' },
      item_number: { notNull: true, dataType: 'string' },
      warehouse: { notNull: true, dataType: 'string' },
      item_description: { notNull: true, dataType: 'string' },
      category: { notNull: true, dataType: 'string' },
      product_family: { notNull: false, dataType: 'string' },
      manufacturer: { notNull: false, dataType: 'string' },
      model: { notNull: false, dataType: 'string' },
      quantity_onhand: { notNull: false, dataType: 'number' },
      quantity_allocated: { notNull: false, dataType: 'number' },
      stocklist_quantity_available: { notNull: false, dataType: 'number' },
      auction_quantity_available: { notNull: false, dataType: 'number' },
      unassigned_quantity_available: { notNull: false, dataType: 'number' },
      increment_size: { notNull: false, dataType: 'number' },
      model_number: { notNull: false, dataType: 'string' },
      capacity: { notNull: false, dataType: 'string' },
      color: { notNull: false, dataType: 'string' },
      carrier: { notNull: false, dataType: 'string' },
      grade: { notNull: false, dataType: 'string' },
      screen_size: { notNull: false, dataType: 'string' },
      protocol: { notNull: false, dataType: 'string' },
      lock_status: { notNull: false, dataType: 'string' },
      channel: { notNull: false, dataType: 'string' },
      casing_size: { notNull: false, dataType: 'string' },
      casing_material: { notNull: false, dataType: 'string' },
      band_material: { notNull: false, dataType: 'string' },
      image_url: { notNull: false, dataType: 'string' },
      price: { notNull: false, dataType: 'number' },
      low_price: { notNull: false, dataType: 'number' },
      cost: { notNull: false, dataType: 'string' },
      update_datetime: { notNull: false, dataType: 'string' },
      display: { notNull: false, dataType: 'number' },
      groupAttributes: { notNull: true, dataType: 'string' },
      groupDescription: { notNull: true, dataType: 'string' },
    },
  };
  const db = {
    name: 'phonex',
    tables: [inventoryTb],
  };
  return db;
};

const populateLocalDb = (resolve: any) => {
  const path = '/px-api-gateway/stock?start=0&limit=987654';
  // console.log('populateLocalDb ====');
  performance.mark('GetServerData:start');
  API.get(apiName, path, extraParams).then(async (res: any) => {
    // console.log('Got Server Data ====', res.results);
    performance.mark('GetServerData:end');
    // console.log(performance.measure('GetServerData', 'GetServerData:start', 'GetServerData:end'));
    setTimeout(() => {
      performance.mark('PopulateDB:start');
      dbConnection.insert({
        into: 'InventoryTb',
        values: res.results,
      });
      performance.mark('PopulateDB:end');
      // console.log(performance.measure('PopulateDB', 'PopulateDB:start', 'PopulateDB:end'));
    }, 1);
    resolve(res.results);
  });
};

export const reactStringReplace = (
  str: string,
  labelStringFormatter: any,
  ReactComponentFormatter: any
) => {
  var parts = str.split(/\{|\}/g);
  var fn = labelStringFormatter,
    output = [];
  for (var i = 0; i < parts.length; i++) {
    output[i] = fn(parts[i], `reactStringReplace-${i}`);
    // toggle between the two functions
    fn = fn === labelStringFormatter ? ReactComponentFormatter : labelStringFormatter;
  }
  return <div className="grid-x align-middle">{output}</div>;
};

export const getInventoryFromLocalDb = () => {
  return new Promise(async (resolve: any) => {
    performance.mark('LoadDataFromLocal:start');
    // console.log('Loading from Local......');
    const result = await dbConnection.select({
      from: 'InventoryTb',
    });
    performance.mark('LoadDataFromLocal:end');
    console.log(
      performance.measure('LoadDataFromLocal', 'LoadDataFromLocal:start', 'LoadDataFromLocal:end')
    );
    resolve(result);
  });
};

export const getStock = () => {
  return new Promise(async (resolve: any) => {
    const db = getDbSchema();
    const isDbCreated = await dbConnection.initDb(db);
    if (isDbCreated) {
      // console.log('Create new DB locally');
      populateLocalDb(resolve);
    } else {
      // console.log('Database already exist, read from local');
      resolve();
    }
  });
};

export const importBulkOffer = (file: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log(file, 'importFile');
      var xmlHttpRequest = new XMLHttpRequest();
      xmlHttpRequest.open(
        'POST',
        `https://m63qk19h95.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/stocklist/offer/bulk-offer-import`,
        true
      );
      xmlHttpRequest.setRequestHeader(
        'Content-Type',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      // xmlHttpRequest.responseType = 'text';
      xmlHttpRequest.setRequestHeader(
        'Authorization',
        `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      );
      xmlHttpRequest.setRequestHeader('Accept', 'application/json');
      xmlHttpRequest.onreadystatechange = function () {
        // In local files, status is 0 upon success in Mozilla Firefox
        if (xmlHttpRequest.readyState === XMLHttpRequest.DONE) {
          if (xmlHttpRequest.status !== 200) {
            reject(JSON.parse(xmlHttpRequest.response));
          }
          // console.log(xmlHttpRequest);
          resolve(JSON.parse(xmlHttpRequest.response));
        }
      };
      xmlHttpRequest.send(file);
    } catch (error: any) {
      reject(error);
    }
  });
};

// const populateLocalDb = async (resolve: any, path: string, dbName: string) => {
//   // console.log('getConfig-------');

//   // const path = '/px-api-gateway/stock?start=0&limit=987654';
//   // console.log('populateLocalDb ====');
//   performance.mark('GetServerData:start');
//   // API.get(apiName, path, extraParams)
//   // const res = await commonService('get', path, {
//   //   headers: {
//   //     'Accept-Encoding': 'gzip',
//   //     'Content-Type': 'application/json',
//   //     // 'Content-Encoding': 'gzip',
//   //     'Accept': '*/*'
//   //   },
//   //   response: true,
//   //   responseType: 'application/json',
//   //   gzip: true
//   // });
//   const { data } = await axios.get('http://phonex-saas-dev-alb1-264851960.us-east-1.elb.amazonaws.com/api/stocklist/pricing/items', {
//     headers: {
//       roles: 'Tenant',
//       email: 'natalie+admin@hylamobile.com',
//       tenant_id: 'T01'
//     }
//   });

//   // var buf = new ArrayBuffer(res.data.length * 2); // 2 bytes for each char
//   // var bufView = new Uint16Array(buf);
//   // for (var i = 0, strLen = res.data.length; i < strLen; i++) {
//   //   bufView[i] = res.data.charCodeAt(i);
//   // }

//   const results = data;

//   // dbName === 'InventoryTb' ? res.data : res.data;
//   // const results = JSON.parse(resultData);

//   // console.log('Got Server Data ====', results);
//   performance.mark('GetServerData:end');
//   // console.log(performance.measure('GetServerData', 'GetServerData:start', 'GetServerData:end'));
//   setTimeout(() => {
//     performance.mark('PopulateDB:start');
//     dbConnection.insert({
//       into: dbName,
//       values: results,
//     });
//     performance.mark('PopulateDB:end');
//     // console.log(performance.measure('PopulateDB', 'PopulateDB:start', 'PopulateDB:end'));
//   }, 1);
//   resolve(results);
// };

export const getFromLocalDb = (dbName: string) => {
  return new Promise(async (resolve: any, reject: any) => {
    performance.mark('LoadDataFromLocal:start');
    const dbConnection = new JsStore.Connection(new Worker('/jsstore.worker.js'));
    // console.log('Loading from Local......');
    let results;
    try {
      // await dbConnection.initDb({
      //   name: 'phonex',
      //   tables: [],
      // });
      results = await dbConnection.select({
        from: dbName,
      });
      performance.mark('LoadDataFromLocal:end');
      console.log(
        performance.measure('LoadDataFromLocal', 'LoadDataFromLocal:start', 'LoadDataFromLocal:end')
      );
      resolve(results);
    } catch (error: any) {
      // console.log('loclaDb error', error);
      reject();
    }
  });
};

export const getChannelSettings = async () => {
  const path = `/px-api-gateway/inventory/settings`;
  const settings = await commonService('get', path, {});
  return settings;
  //dispatch(channelSetting(settings));
};

export const getChannelItems = () => {
  return new Promise(async (resolve: any) => {
    //const db = getChannelDbSchema();
    //const isDbCreated = await dbConnection.initDb(db);
    if (true) {
      // console.log('Create new DB locally');
      const path = `/px-api-gateway/inventory/items`;
      const results = await commonService('get', path, {});
      resolve(results);
      //populateLocalDb(resolve, `/px-api-gateway/inventory/items`, 'ChannelTb');
    }
    // else {
    //   populateLocalDb(resolve, `/px-api-gateway/inventory/items`, 'ChannelTb');
    //   // console.log('Database already exist, read from local');
    //resolve();}
  });
};

export const getServerURL = (dbName: string) => {
  let url: string = '';
  switch (dbName) {
    case 'InventoryTb':
      url = '';
    // break;
  }

  return url;
};

export const getPricing = async () => {
  const path = '/px-api-gateway/stocklist/pricing/items';
  return await commonService('get', path, {});
};

export const setPriceSettings = () => {
  return new Promise(async (resolve: any) => {
    // const db = getDbSchema();
    const path = '/px-api-gateway/stocklist/pricing/settings';
    const res = await commonService('get', path, {});
    resolve(res);
  });
};

export const getInventory = () => {
  return new Promise(async (resolve: any) => {
    const path = '/px-api-gateway/inventory/items';
    const res = await commonService('get', path, {});
    if (res) {
      resolve(res);
    }
  });
};

export const setInventorySettings = () => {
  return new Promise(async (resolve: any) => {
    const path = '/px-api-gateway/inventory/settings';
    const res = await commonService('get', path, {});
    resolve(res);
  });
};

export const setDataInLocalDB = (data: any, dbName: string) => {};

export const getDataInLocalDB = (dbName: string) => {
  return new Promise((resolve: any, reject: any) => {
    getFromLocalDb(dbName).then((stockFromLocal) => {
      resolve(stockFromLocal);
    });
    //     .catch((e: any) => {
    //       reject(e);
    //     });
  });
};

export const getFilter = () => {
  return new Promise((resolve: any) => {
    const localFilter = localStorage.getItem('PxFilter');
    if (localFilter) {
      resolve(JSON.parse(localFilter));
    } else {
      const path = '/px-api-gateway/filter';
      API.get(apiName, path, extraParams).then(async (res: any) => {
        localStorage.setItem('PxFilter', JSON.stringify(res));
        resolve(res);
      });
    }
  });
};

export const getDummyGroupStock = () => {
  return new Promise(async (resolve: any) => {
    performance.mark('getGroupStock:start');
    // console.log('getGroupStock');
    ldb.get('PxStockGroup', (value: any) => {
      if (value) {
        resolve(JSON.parse(value));
        // console.log('getGroupStock - got from local');
        performance.mark('getGroupStock:end');
        console.log(
          performance.measure('getGroupStock', 'getGroupStock:start', 'getGroupStock:end')
        );
      } else {
        const path = '/px-api-gateway/stock/group';
        API.get(apiName, path, extraParams).then(async (res: any) => {
          localStorage.setItem('PxStockTotalCount', res.totalCount);
          ldb.set('PxStockGroup', JSON.stringify(res.results));
          // console.log('getGroupStock - got from remote');
          resolve(res.results);
          performance.mark('getGroupStock:end');
          console.log(
            performance.measure('getGroupStock', 'getGroupStock:start', 'getGroupStock:end')
          );
        });
      }
    });
  });
};

export const getGroupStock = () => {
  return new Promise(async (resolve: any) => {
    performance.mark('getGroupStock:start');
    // console.log('getGroupStock');
    const path = '/px-api-gateway/stocklist/items';
    API.get(apiName, path, extraParams).then(async (res: any) => {
      //localStorage.setItem('PxStockTotalCount', res.totalCount);
      //ldb.set('PxStockGroup', JSON.stringify(res.results));
      // console.log('getGroupStock - got from remote');
      resolve(res);
      performance.mark('getGroupStock:end');
      // console.log(performance.measure('getGroupStock', 'getGroupStock:start', 'getGroupStock:end'));
    });
  });
};

// // TODO: helper function
// export const disableField = (array: Array<any>, field: any) => {
//   array.forEach((ele: any, idx: number) => {
//     if (ele.id === field) {
//       ele.disabled = true;
//       array[idx] = ele;
//     }
//   });
// }


// CRUD Customers
export const createCustomers = () => {};

export const createCustomer = async (customer: any) => {
  const path = '/px-api-gateway/account/buyer';
  const customerData = await commonService('post', path, { body: customer });
  // // console.log(customerData, customer);
  if (customerData.success) {
    const salesRep = await getSalesRep(customer.salesRepId);
    if (!salesRep || salesRep.error) {
      // handle error
      return;
    }
    customer.id = customerData.id;
    customer.salesRep = salesRep;
    customer.active = true;
    return customer;
  }
  return customer;
};

export const getCustomers = async () => {
  const path = '/px-api-gateway/account/buyers';
  const customers = await commonService('get', path, {});
  return customers;
};

export const getCustomer = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}`;
  const customer = await commonService('get', path, {});
  return customer;
};

export const updateCustomer = async (buyerNumber: string | number, buyerDetails: any) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}`;
  const res = await commonService('put', path, {
    body: buyerDetails,
  });
  return res;
};

export const getMyCustomer = async () => {
  const path = `/px-api-gateway/account/my-buyers`;
  const res = await commonService('get', path, {});
  if (!res || res.error) {
    // TODO: Error
    return [];
  }
  return res;
};

export const deleteCustomer = async () => (dispatch: any) => {};

// Check Customer Exists
export const customerExists = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/exist`;
  const exists = await commonService('get', path, {});
  if (typeof exists !== 'boolean') {
    // TODO: Error
    return true;
  }
  return exists;
};

// Activate/Deactivate customer
export const activateCustomer = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/activate`;
  const customer = await commonService('put', path, {
    body: {},
  });
  return customer;
};

export const deactivateCustomer = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/deactivate`;
  const customer = await commonService('put', path, {
    body: {},
  });
  return customer;
};

// CRUD Address
export const createAddress = async (buyerNumber: string | number, address: any) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/address`;
  const res = await commonService('post', path, {
    body: address,
  });
  return res;
};

export const getAddresses = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/addresses`;
  const addresses = await commonService('get', path, {});
  return addresses;
};

export const getAddress = async (buyerNumber: string | number, addressCode: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/address/${addressCode}`;
  const address = await commonService('get', path, {});
  return address;
};

export const updateAddress = async (buyerNumber: string | number, address: any) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/address/${address.id}`;
  // put
  const res = await commonService('put', path, {
    body: address,
  });
  return res;
};

export const deleteAddress = async (buyerNumber: string | number, addressCode: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/address/${addressCode}`;
  // DELETE
  const res = await commonService('delete', path, {});
  return res;
};

// CRUD Payment Method
export const getPaymentMethods = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/paymentmethods`;
  const paymentMethods = await commonService('get', path, {});
  return paymentMethods;
};

export const updatePaymentMethod = async (buyerNumber: string | number, paymentMethods: any) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/paymentmethods`;
  // put
  const res = await commonService('put', path, {
    body: paymentMethods,
  });
  return res;
};

// CRUD Shopping Channels
export const getShoppingChannels = async (buyerId: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerId}/additional-channels`;
  const shoppingMethods = await commonService('get', path, {});
  return shoppingMethods;
};

export const setShoppingChannels = async (buyerId: string | number, shoppingMethods: any) => {
  const path = `/px-api-gateway/account/buyer/${buyerId}/additional-channels`;
  const shoppingMethodsRes = await commonService('put', path, {
    body: shoppingMethods,
  });
  // console.log(shoppingMethodsRes, 'at setShoppingChannels');
  return shoppingMethodsRes;
};

// CRUD SalesRep
export const createSalesRep = async () => (dispatch: any) => {};

export const getSalesReps = async () => {
  const path = '/px-api-gateway/account/salesreps';
  const salesReps = await commonService('get', path, {});
  if (salesReps.error) {
    // TODO: Error
    return [];
  }
  return salesReps;
};

export const getSalesRep = async (salesRepId: string | number) => {
  const path = `/px-api-gateway/account/salesrep/${salesRepId}`;
  const salesRep = await commonService('get', path, {});
  return salesRep;
};

export const updateSalesRep = async () => (dispatch: any) => {};

export const deleteSalesRep = async () => (dispatch: any) => {};

// CRUD customer User
export const createCustomerUser = async (buyerNumber: string | number, userData: any) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/user`;
  const customerUser = await commonService('post', path, {
    body: userData,
  });
  // console.log('customer user created response::::::', customerUser);
  return customerUser;
};

export const getCustomerUsers = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/users`;
  const customerUser = await commonService('get', path, {});
  return customerUser;
};

export const getCustomerUser = async (userId: string | number) => {
  // const path = `/px-api-gateway/account/salesrep/${salesRepId}`;
  // const users = await commonService("get", path, {});
  // if (salesRep.error) {
  //   // TODO: Error
  //   return;
  // }
  // return users;
};

export const updateCustomerUser = async (
  buyerNumber: string | number,
  userId: string | number,
  user: any
) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/user/${userId}`;
  const customerUser = await commonService('put', path, {
    body: user,
  });
  return customerUser;
};

export const deleteCustomerUser = async () => (dispatch: any) => {};

export const activateCustomerUser = async (
  buyerNumber: string | number,
  userId: string | number
) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/user/${userId}/activate`;
  const res = await commonService('put', path, {
    body: {},
  });
  return res;
};

export const deactivateCustomerUser = async (
  buyerNumber: string | number,
  userId: string | number
) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/user/${userId}/deactivate`;
  const res = await commonService('put', path, {
    body: {},
  });
  return res;
};

export const resetPassword = async (buyerId: string | number, userId: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerId}/user/${userId}/resetPassword`;
  const res = await commonService('put', path, {
    body: {},
  });
  return res;
};

// CRUD Documents
export const createDocument = async (
  buyerNumber: string | number,
  fileTitle: string,
  expiryDate: any,
  file: any
) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/document/upload/details`;
  const formData = new FormData();
  formData.append('file', file);
  // // console.log('PxCurrencySymbol said form data', formData);

  const users = await commonService('post', path, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'file-title': fileTitle,
      'file-expiration-date': expiryDate,
    },
    body: formData,
  });
  return users;

  // try {
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   // console.log(file);

  //   const session = await Auth.currentSession();
  //   const token = session.getIdToken().getJwtToken();
  //   // awsconfig here is the configuration you setup to use amplify already with your app
  //   // dynamic generation of url
  //   const url = 'https://m63qk19h95.execute-api.us-east-1.amazonaws.com/Integration' + path;
  //   // TODO: add title and expiry date
  //   const res: any = await axios.post(url, formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //       Authorization: `Bearer ${token}`,
  //       // 'file-title': fileTitle,
  //       // 'file-expiration-date': expiryDate,
  //     },
  //   });
  //   return res;
  // } catch (e: any) {
  //   return {
  //     timestamp: Date.now(),
  //     status: e.status,
  //     error: e.message,
  //     message: e.message,
  //     path: path,
  //   }
  // }
};

export const getDocuments = async (buyerNumber: string | number) => {
  const path = `/px-api-gateway/account/buyer/${buyerNumber}/documents`;
  const documents = await commonService('get', path, {});
  return documents;
};

export const getDocumentDownloadableURL = async (buyerId: string | number, key: string) => {
  const path = `/px-api-gateway/account/buyer/${buyerId}/document/URL/${key}`;
  const url = await commonService('get', path, {});
  return url;
};

export const getDocument = async (buyerNumber: string | number, documentLink: string) => {
  // const path = `/px-api-gateway/account/buyer/${buyerNumber}/document/URL/${documentLink}`;
  // const users = await commonService("get", path, {});
  // if (salesRep.error) {
  //   // TODO: Error
  //   return;
  // }
  // return users;
};

export const deleteDocument = async (buyerId: string | number, key: string) => {
  const path = `/px-api-gateway/account/buyer/${buyerId}/document/delete/${key}`;
  const url = await commonService('delete', path, {});
  return url;
};

export const downloadFile = async (file: any, fileName?: string) => {
  let name = file.headers['content-disposition']
    ? file.headers['content-disposition'].split('=')[1].trim()
    : fileName;
  name = name.replace(/(^"|"$)/g, '')
  const href = window.URL.createObjectURL(file.data);
  const link = document.createElement('a');
  link.href = href;
  link.style.display = 'none';
  link.setAttribute('download', name); //or any other extension
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(href);
  return true;
};

// download pricing item export
export const getExportPricing = async () => {
  // return await downloadFile('/px-api-gateway/stocklist/pricing/exportitems');
};

// update pricing
export const updatePricingQty = async (values: any) => {
  return await commonService(
    'put',
    `/px-api-gateway/stocklist/pricing/item/${values.itemNumberWarehouse}`,
    {
      body: {
        itemNumberWarehouse: values.itemNumberWarehouse,
        newLowPrice: values.lowPrice,
        newListPrice: values.listPrice,
      },
    }
  );
};

// delete
export const deleteDraft = async (itemNumberWarehouse: StringConstructor) => {
  return await commonService(
    'delete',
    `/px-api-gateway/stocklist/pricing/item/${itemNumberWarehouse}`,
    {
      body: {},
    }
  );
};

// publish pricing
export const publishPricingDraft = async () => {
  return await commonService('post', `/px-api-gateway/stocklist/pricing/publish-draft`, {
    body: {},
    responseType: 'text',
  });
};

// approval pricing
export const submitForApproval = async () => {
  return await commonService('post', `/px-api-gateway/stocklist/pricing/submit-for-approval`, {
    body: {},
    responseType: 'text',
  });
};

// approval pricing
export const rejectDraft = async () => {
  return await commonService('post', `/px-api-gateway/stocklist/pricing/reject-draft`, {
    body: {},
  });
};

// import pricing
export const importPricing = (file: any) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log(file, 'importPricing');
      var xmlHttpRequest = new XMLHttpRequest();
      xmlHttpRequest.open(
        'POST',
        `https://m63qk19h95.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/stocklist/pricing/import-pricing-file`,
        true
      );
      xmlHttpRequest.setRequestHeader(
        'Content-Type',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      );
      // xmlHttpRequest.responseType = 'text';
      xmlHttpRequest.setRequestHeader(
        'Authorization',
        `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      );
      xmlHttpRequest.setRequestHeader('Accept', 'application/json');
      xmlHttpRequest.setRequestHeader('file-name', file.name);
      xmlHttpRequest.onreadystatechange = function () {
        // In local files, status is 0 upon success in Mozilla Firefox
        if (xmlHttpRequest.readyState === XMLHttpRequest.DONE) {
          if (xmlHttpRequest.status !== 200) {
            reject(JSON.parse(xmlHttpRequest.response));
          }
          // console.log(xmlHttpRequest);
          resolve(JSON.parse(xmlHttpRequest.response));
        }
      };
      xmlHttpRequest.send(file);
    } catch (error: any) {
      reject(error);
    }
  });
};

export const itemGroupAverageBookedPrice = (params: IAggFuncParams) => {
  if (params.values.length) {
    const sum = {
      totalBookedInPeriodExtendedPrice: 0,
      totalBookedInPeriod: 0,
    };
    params.rowNode.childrenAfterFilter.forEach((val) => {
      if (!val.data?.totalBookedInPeriod) return;
      sum.totalBookedInPeriodExtendedPrice += +(val.data?.totalBookedInPeriodExtendedPrice || 0);
      sum.totalBookedInPeriod += +(val.data?.totalBookedInPeriod || 0);
    });

    return averageBookedPriceFormula(sum.totalBookedInPeriod, sum.totalBookedInPeriodExtendedPrice);
  }
  return null;
  // return 50;
};

export const averageBookedPrice = ({ data }: any) => {
  // Extended Booked Price / Total Booked
  return averageBookedPriceFormula(data.totalBookedInPeriod, data.totalBookedInPeriodExtendedPrice);
};

const averageBookedPriceFormula = (
  totalBookedInPeriod: any,
  totalBookedInPeriodExtendedPrice: any
) => {
  if (!totalBookedInPeriod) return 0;
  return totalBookedInPeriodExtendedPrice / totalBookedInPeriod;
};

export const averageBookedCost = (params: any) => {
  if (params.node?.isRowPinned()) console.log(params.data);

  const { data } = params;
  // Extended Booked Cost / Total Booked
  return averageBookedCostFormula(data.totalBookedInPeriod, data.totalBookedInPeriodExtendedCost);
};

export const itemGroupAverageBookedCost = (params: IAggFuncParams) => {
  if (params.values.length) {
    const sum = {
      totalBookedInPeriodExtendedCost: 0,
      totalBookedInPeriod: 0,
    };
    params.rowNode.childrenAfterFilter.forEach((val) => {
      if (!val.data?.totalBookedInPeriod) return;
      sum.totalBookedInPeriodExtendedCost += +(val.data?.totalBookedInPeriodExtendedCost || 0);
      sum.totalBookedInPeriod += +(val.data?.totalBookedInPeriod || 0);
    });

    return averageBookedCostFormula(sum.totalBookedInPeriod, sum.totalBookedInPeriodExtendedCost);
  }
  return null;
};

const averageBookedCostFormula = (
  totalBookedInPeriod: any,
  totalBookedInPeriodExtendedCost: any
) => {
  if (!totalBookedInPeriod) return 0;
  if (!totalBookedInPeriodExtendedCost) return null;
  // checkNullOrUndefined(totalBookedInPeriodExtendedCost)
  return (+totalBookedInPeriodExtendedCost / totalBookedInPeriod).toFixed(2);
};

export const marginBookedPercent = ({ data }: any) => {
  return marginBookedPercentFormula(
    data.totalBookedInPeriodExtendedPrice,
    data.totalBookedInPeriodExtendedCost
  );
};

export const itemGroupMarginBookedPercent = (params: IAggFuncParams) => {
  if (params.values.length) {
    const sum = {
      totalBookedInPeriodExtendedPrice: 0,
      totalBookedInPeriodExtendedCost: 0,
    };
    params.rowNode.childrenAfterFilter.forEach((val) => {
      if (!val.data?.totalBookedInPeriodExtendedPrice) return;
      sum.totalBookedInPeriodExtendedPrice += +(val.data?.totalBookedInPeriodExtendedPrice || 0);
      sum.totalBookedInPeriodExtendedCost += +(val.data?.totalBookedInPeriodExtendedCost || 0);
    });

    return marginBookedPercentFormula(
      sum.totalBookedInPeriodExtendedPrice,
      sum.totalBookedInPeriodExtendedCost
    );
  }
  return null;
};

const marginBookedPercentFormula = (
  totalBookedInPeriodExtendedPrice: any,
  totalBookedInPeriodExtendedCost: any
) => {
  // (Extended Booked Price - Extended Booked Cost)/Extended Booked Price
  if (!totalBookedInPeriodExtendedPrice) return Infinity;
  if (!totalBookedInPeriodExtendedCost) return null;
  const diff = totalBookedInPeriodExtendedPrice - totalBookedInPeriodExtendedCost;
  return ((diff * 100) / totalBookedInPeriodExtendedPrice).toFixed(2);
};

export const estimatedDaysToSell = (days: number) => ({ data }: any) => {
  return estimatedDaysToSellFormula(data.totalBookedInPeriod, data.currentAvailableQuantity, days);
};

export const estimatedDaysToSellPrefetch = (days: number, data: any) => {
  // if (days < 0 || data.currentAvailableQuantity < 0 || data.totalBookedInPeriod < 0) {
  //   console.log(data, 'negative est days to sell', days);
  // }
  return estimatedDaysToSellFormula(data.totalBookedInPeriod, data.currentAvailableQuantity, days);
};

export const itemGroupEstimatedDaysToSell = (days: number) => (params: IAggFuncParams) => {
  if (params.values.length) {
    const sum = {
      totalBookedInPeriod: 0,
      currentAvailableQuantity: 0,
    };
    params.rowNode.childrenAfterFilter.forEach((val) => {
      if (!val.data?.totalBookedInPeriod) {
        return;
      }
      sum.totalBookedInPeriod += +(val.data?.totalBookedInPeriod || 0);
      sum.currentAvailableQuantity += +(val.data?.currentAvailableQuantity || 0);
    });

    return estimatedDaysToSellFormula(sum.totalBookedInPeriod, sum.currentAvailableQuantity, days);
  }
  return null;
};

const estimatedDaysToSellFormula = (
  totalBookedInPeriod: any,
  currentAvailableQuantity: any,
  days: number
) => {
  if (!totalBookedInPeriod) return Infinity;

  if (!days || !currentAvailableQuantity) return 0;
  //  A = Current quantity available for sale
  // B = Total Booked in Period / Number of days in period
  // Estimated Days to Book = A / B
  return ((currentAvailableQuantity * days) / totalBookedInPeriod).toFixed(2);
};

export const dayOfInventory = (days: number) => (params: ValueGetterParams) => {
  if (!params.data) return null;
  return dayOfInventoryFormula(
    params.data.periodBeginningOnHand,
    params.data.periodEndingOnHand,
    params.data.soldInPeriod,
    days
  );
};

export const itemGroupDayOfInventory = (days: number) => (params: IAggFuncParams) => {
  if (params.values.length) {
    const sum = {
      periodBeginningOnHand: 0,
      periodEndingOnHand: 0,
      soldInPeriod: 0,
    };
    params.rowNode.childrenAfterFilter.forEach((val) => {
      if (!val.data?.soldInPeriod) return;
      sum.periodBeginningOnHand += +(val.data?.periodBeginningOnHand || 0);
      sum.periodEndingOnHand += +(val.data?.periodEndingOnHand || 0);
      sum.soldInPeriod += +(val.data?.soldInPeriod || 0);
    });

    return dayOfInventoryFormula(
      sum.periodBeginningOnHand,
      sum.periodEndingOnHand,
      sum.soldInPeriod,
      days
    );
  }
  return null;
};

const dayOfInventoryFormula = (startQty: any, endQty: any, soldInventory: any, days: number) => {
  // Days Inventory when Sold equals 0 is 9999
  if (!soldInventory) return Infinity;

  if ((checkNullOrUndefined(startQty) && checkNullOrUndefined(endQty)) || !days) return null;
  //   Average Inventory = (Start Qty + End Qty) / 2
  const averageInventory = (+startQty + +endQty) / 2;
  // Days Inventory when Sold is GT than 0 is
  // = (Average Inventory / Sold ) * Number of days in period
  return ((averageInventory * days) / soldInventory).toFixed(2);
};

export const getImportPricingSummary = async () => {
  return await commonService('get', `/px-api-gateway/stocklist/pricing/import-summary`, {
    body: {},
  });
};

export const acceptPricingImport = async (reqBody: any) => {
  return await commonService('post', `/px-api-gateway/stocklist/pricing/accept-import`, {
    responseType: 'text',
    body: reqBody,
  });
};

export const cancelPricingImport = async () => {
  return await commonService('post', `/px-api-gateway/stocklist/pricing/cancel-import`, {
    body: {},
  });
};


//
export const orderDetailsMessages = {
  disabledFulfillmentStatus: {
    AWAITING_PAYMENT: 'To select Awaiting Payment status please change payment status',
    PARTIALLY_SHIPPED: 'Update some item qty as shipped first',
    SHIPPED: 'Update all item qty as shipped first',
    INVOICED: 'only enabled if status is “Shipped”',
  },
  disabledPaymentStatus: {
    PAID: 'Please update fulfillment status first',
  },
};

// field validation
export const fieldValidation = (value: string, type: string) => {
  let errorValRes = '';
  switch (type) {
    case 'alphanumeric':
      if (!value.match(/^([0-9]|[a-z])+([0-9a-z]+)$/i)) {
        errorValRes = 'Please enter alpha numeric value of buyer';
      }
      break;
    case 'atleast-one-alphabet':
      if (!value.match(/^[a-z]+[a-z0-9]*/i)) {
        errorValRes = 'Please start with atleast one alphabet';
      }
      break;
    case 'number':
      if (!value.match(/^[0-9]+$/i)) {
        errorValRes = 'Invalid number';
      }
      break;
    case 'internationalized-zip':
      // eslint-disable-next-line no-useless-escape
      if (
        value.match(/(^[-]+[\S \n]*[-]*$)|(^[-]*[\S \n]*[-]+$)/gi) ||
        // eslint-disable-next-line no-useless-escape
        !value.match(/^[a-z0-9\-]+[\s]?[a-z0-9\-]*$/i)
      ) {
        errorValRes = 'Invalid zip';
      }
      break;
    case 'required':
      if (!value) {
        errorValRes = 'Required field';
      }
      break;
    case 'email':
      // eslint-disable-next-line no-useless-escape
      if (!value.match(/^[\w-\.+]{1,64}@[\w-].{1,252}$/g)) {
        errorValRes = 'invalid email';
      }
      break;
    case 'tel': {
      // eslint-disable-next-line no-useless-escape
      if (!value.match(/^[+]?[0-9/() .\-\/]{10,15}/g) || value.match(/[a-z]/g)) {
        // telephone validation
        errorValRes = 'invalid telephone number';
      }
      break;
    }
    // atleast on alphabet and other can be numbers => country/state/city
    // numbers with special characters => zip
    case 'text':
      break;
  }
  return errorValRes;
};

export const commonService = async (
  method: string,
  path: string,
  additionalParams: any,
  permission?: string
) => {
  try {
    let result: any;
    const upperCaseMethod = method.toUpperCase();
    switch (upperCaseMethod) {
      case 'GET': {
        result = await API.get(apiName, path, additionalParams);
        break;
      }
      case 'POST': {
        result = await API.post(apiName, path, additionalParams);
        break;
      }
      case 'PUT': {
        result = await API.put(apiName, path, additionalParams);
        break;
      }
      case 'PATCH': {
        result = await API.patch(apiName, path, additionalParams);
        break;
      }
      case 'DELETE': {
        result = await API.del(apiName, path, additionalParams);
        break;
      }
      default: {
        result = {};
      }
    }

    if (
      upperCaseMethod === 'POST' &&
      ((additionalParams && additionalParams.responseType === 'text' && result) ||
        result?.id ||
        !result)
    ) {
      // you'll get id here
      return {
        ...result,
        success: true,
      };
    }

    if (upperCaseMethod === 'PUT' || upperCaseMethod === 'DELETE') {
      if (!result || (typeof result === 'object' && Object.keys(result).length === 0)) {
        return {
          success: true,
        };
      }
    }

    if (upperCaseMethod === 'GET' && (!result.status || result.status === 200)) {
      return result;
    }

    if (!result) {
      // throw new Error('Internal Service Error');

      return {
        status: 500,
        message: 'Internal Service Error',
        error: true,
      };
    }
    return {
      status: result.statusCode,
      message: result.message,
      error: true,
    };
  } catch (e: any) {
    // console.log(e, 'error occurred at common service lib');
    if (e.code === 'NotAuthorizedException') {
      // redirect
      <Redirect />;
      return;
    }
    return {
      timestamp: Date.now(),
      status: e.status,
      error: 'Connection Error',
      message: e.message,
      path: path,
    };
  }
};

const Redirect = () => {
  const history = useHistory();
  history.push('/customers');
  return <></>;
};

export const customerMessages = {
  updateCustomerSuccessMessage: 'Customer Updated successfully',
  addCustomerSuccessMessage: 'Customer Added successfully',
  activatedCustomerSuccessMessage: 'Customer Activated Successfully',
  deactivatedCustomerSuccessMessage: 'Customer Deactivated Successfully',
  compulsoryFields: [
    {
      id: 'buyerNumber',
      label: 'Customer Number',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'buyerName',
      label: 'Customer Name',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'salesRepId',
      label: 'Sales Representative',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'state',
      label: 'State',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'country',
      label: 'Country',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'phone',
      label: 'Phone',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'email',
      label: 'Email',
      type: 'text',
      required: true,
      maxLength: null,
    },
    {
      id: 'whatsApp',
      label: 'WhatsApp',
      type: 'text',
      required: true,
      maxLength: null,
    },
  ],
};

export const messages: any = {
  inventoryImportError: {
    label: 'Errors found (will be skipped)',
    DUPLICATE_SKU_FOR_WAREHOUSE: {
      label: 'Duplicate SKUs for Warehouse',
    },
    INVALID_WAREHOUSE: {
      label: 'Invalid SKU or Warehouse',
    },
    INVALID_CATEGORY: {
      label: 'Invalid Category',
    },
    INVALID_GRADE: {
      label: 'Invalid Grade',
    },
    MISSING_REQUIRED_ATTRIBUTE: {
      label: 'Missing required attribute',
    },
    MISSING_QUANTITY: {
      label: 'Missing Quantity',
    },
    INVALID_QUANTITY: {
      label: 'Invalid Quantity',
    },
  },
  inventoryImportWarning: {
    label: 'Warnings found',
    BACKORDER: {
      label: 'Quantity adjustments cause backorders',
    },
    INCREMENT_MISMATCH: {
      label: 'Quantity adjustments do not match Increments',
    },
    MISSING_COST: {
      label: 'Missing Cost',
    },
  },
  inventoryImportUpdate: {
    label: 'Changes found',
    NEW_SKU: {
      label: 'NEW SKUs will be added',
      id: ['itemNumber'],
    },
    DESC_UPDATED: {
      label: 'SKUs will have Description updated',
    },
    COST_UPDATED: {
      label: 'SKUs will have Cost updated',
      id: ['cost'],
    },
    QUANTITY_UPDATED: {
      label: 'SKUs will have Quantity updated',
      id: ['quantityOnHand'],
    },
    INCREMENT_SIZE_UPDATED: {
      label: 'SKUs will have Increments updated',
      id: ['incrementSize'],
    },
  },

  imeiImportError: {
    label: 'Errors found (will be skipped)',
    INVALID_SKU_WAREHOUSE: {
      label: 'Invalid SKUs for Warehouse',
    },
    INVALID_QUANTITY: {
      label: 'Invalid Quantity',
    },
    INVALID_ORDER_NUMBER: {
      label: 'Invalid Order Number',
    },
    IMEIS_EXCEEDS_SHIPPED_COUNTS: {
      label: 'IMEI Exceeds Shipped Counts',
    },
    DUPLICATE_IMEI: {
      label: 'Duplicate IMEI',
    },
  },
  imeiImportWarning: {
    label: 'Warnings found',
    IMEIS_LESS_THAN_PREVIOUS_IMEI_COUNTS: {
      label: 'IMEI less than previous IMEI counts',
    },
    MISSING_INVOICE_OR_TRACKING_NUMBER: {
      label: 'Missing invoice or tracking number',
    },
  },
  imeiImportUpdate: {
    label: 'Changes found',
    VALID: {
      label: 'IMEIs Added',
    },
  },

  orderImportError: {
    label: 'Errors Found (will be skipped)',
    ORDER_NOT_FOUND: {
      label: 'Order(s) where PhoneX Order Number is not found',
    },
    CONFLICTING_FULFILMENT_STATUSES: {
      label: 'Order(s) where Ref Fulfillment Status does not match for all items',
    },
    CONFLICTING_PAYMENT_STATUSES: {
      label: 'Order(s) where Ref Payment Status does not match for all items',
    },
    INVALID_FULFILMENT_STATUS: {
      label: 'Order(s) where Ref Fulfillment Status is invalid',
    },
    INVALID_PAYMENT_STATUS: {
      label: 'Order(s) where Ref Payment Status is invalid',
    },
    FULFILLMENT_STATUS_CHANGE_NOT_ALLOWED: {
      label: 'Order(s) where Ref Fulfillment Status change is not allowed',
    },
    ILLEGAL_PAYMENT_FULFILLMENT_STATUS_COMBINATION: {
      label: 'Order(s) where Ref Payment Status and Ref Fulfillment Status combination is invalid',
    },
    LINE_ITEM_NOT_FOUND: {
      label: 'Order(s) with Item Number not found',
    },
    INVALID_UNIT_PRICE: {
      label: 'Order(s) with Item where Unit Price is invalid',
    },
    INVALID_ORDERED_QUANTITY: {
      label: 'Order(s) with Item where Ordered quantity is invalid',
    },
    INVALID_SHIPPED_QUANTITY: {
      label: 'Order(s) with Item where Shipped quantity is invalid',
    },
    CANNOT_REDUCE_SHIPPED_QUANTITY: {
      label:
        'Order(s) with Item where Shipped quantity is less than quantity already marked shipped',
    },
    SHIPPED_QTY_MORE_THAN_ORDERED_QTY: {
      label: 'Order(s) with Item where Shipped quantity is more than Ordered quantity',
    },
    CANNOT_MODIFY_SHIPPED_ORDER_LINE_ITEM: {
      label: 'Order(s) already Shipped cannot have changes to an Item',
    },
    QUANTITY_NOT_AVAILABLE: {
      label: 'Order(s) with Item where the Available quantity is insufficient for Ordered quantity',
    },
    CANNOT_EDIT_FEES_ON_SHIPPED_ORDER: {
      label: 'Order(s) with missing info for an existing line item',
    },
    INVALID_SHIPPED_COUNT_FOR_STATUS: {
      label: 'Order(s) with Item where Shipped quantity is invalid for Ref Fulfillment Status',
    },
    UPLOAD_MISSING_ORDER_LINE_ITEM: {
      label: 'Order(s) already Shipped cannot have changes to Fees',
    },
  },
  orderImportWarning: {
    label: 'Warnings Found',
    NO_FREIGHT_CHARGE: {
      label: 'Order(s) where Freight is blank',
    },
    NO_PAYMENT_FEE: {
      label: 'Order(s) where Payment Fee is blank',
    },
    NO_TAX: {
      label: 'Order(s) where Tax is blank',
    },
    NO_ADDITIONAL_SERVICES_FEE: {
      label: 'Order(s) where Additional Service Fee is blank',
    },
    UNIT_PRICE_REDUCED: {
      label: 'Order(s) with Item where Unit Price will be lowered',
    },
    CANCELING_LINE_ITEM: {
      label: 'Order(s) with Item that will be canceled',
    },
  },
  orderImportUpdate: {
    label: 'Changes Found',
    SALES_ORDER_DETAILS_UPDATED: {
      label: 'Order(s) where order details will be updated',
    },
    LINE_ITEM_UPDATED: {
      label: 'Order(s) where Items will be updated',
    },
  },
  order: {
    label: 'Review Order Details Import Changes',
    importUrlKey: 'orderImportAccept',
    keyGroup: {
      errors: 'orderImportError',
      warnings: 'orderImportWarning',
      updates: 'orderImportUpdate',
    },
  },

  pricingImportError: {
    label: 'Errors found (will be skipped)',
    INVALID_SKU: {
      label: 'Invalid SKU',
    },
    MISSING_LOW_OR_LIST: {
      label: 'Missing Low Or List',
    },
    INVALID_LOW_OR_LIST: {
      label: 'Invalid Low Or List',
    },
    LOW_PRICE_MORE_THAN_LIST_PRICE: {
      label: 'Low Price is more than List Price',
    },
  },
  pricingImportWarning: {
    label: 'Warnings found',
    WILL_OVERWRITE_UNPUBLISHED_PRICE: {
      label: 'will overwrite unpublished changes',
    },
    SAME_LOW_AND_LIST: {
      label: 'Same Low and List',
    },
  },
  pricingImportUpdate: {
    label: 'Changes found',
    PRICE_UPDATED: {
      label: 'Pricing Updated',
      id: ['importLowPrice', 'importListPrice'],
    },
  },
  pricing: {
    label: 'Review Pricing Import Changes',
    importUrlKey: 'pricingImportAccept',
    keyGroup: {
      errors: 'pricingImportError',
      warnings: 'pricingImportWarning',
      updates: 'pricingImportUpdate',
    },
  },

  customerImportError: {
    label: 'Errors found (will be skipped)',
    INVALID_SALES_REP: {
      label: 'Missing/Invalid SalesRep Id',
    },
    INVALID_EMAIL: {
      label: 'Invalid Customer Email',
    },
    INVALID_SALES_REP_DETAILS: {
      label: 'Invalid Sales Rep Details',
    },
    INVALID_STATUS: {
      label: 'Invalid Status',
    },
    DUPLICATE_EMAIL: {
      label: 'Duplicate Customer Email',
    },
    DUPLICATE_PHONEX_CUSTOMER_NUMBER: {
      label: 'Duplicate Phonex Customer #',
    },
    DUPLICATE_REF_CUSTOMER_NUMBER: {
      label: 'Duplicate Ref Customer #',
    },
    SALES_REP_NOT_FOUND: {
      label: 'Sales Rep Not Found',
    },
    CUSTOMER_NOT_FOUND: {
      label: 'Customer Not Found',
    },
    MISSING_CUSTOMER_NAME: {
      label: 'Missing Customer Name',
    },
    MISSING_PHONEX_CUSTOMER_NUMBER: {
      label: 'Missing Phonex Customer #',
    },
    MISSING_REF_CUSTOMER_NUMBER: {
      label: 'Missing Ref Customer #',
    },
    MISSING_REQUIRED_ADDITIONAL_FIELD: {
      label: 'Missing one of the required additional field columns',
    },
    MISSING_REQUIRED_ADDITIONAL_FIELD_VALUE: {
      label: 'Missing one of the required additional fields',
    },
    CUSTOMER_NUMBER_ALREADY_EXIST: {
      label: 'Customer Number Already Exist',
    },
    CUSTOMER_NAME_ALREADY_EXISTS: {
      label: 'Customer Name Already Exist',
    },
    REF_CUSTOMER_NUMBER_ALREADY_EXIST: {
      label: 'Ref Customer # Already Exist',
    },
    FIELD_EXCEEDS_LENGTH: {
      label: 'Customer Fields exceed Length',
    },
  },
  customerImportWarning: {
    STATUS_CHANGE: {
      label: 'Customer Status Change',
      id: ['active'],
    },
    INVALID_SALES_REP_DETAILS: {
      label: 'Invalid Sales Rep Details',
    },
    CUSTOMER_NAME_ALREADY_EXISTS: {
      label: 'Customer Name Already Exists',
    },
    DUPLICATE_CUSTOMER_NAME: {
      label: 'Duplicate Customer Name',
    },
  },
  customerImportUpdate: {
    UPDATED: {
      label: 'Updated',
    },
    NEW: {
      label: 'New Customer',
    },
  },

  addressImportError: {
    label: 'Errors found (will be skipped)',
    ADDRESS_NOT_FOUND: {
      label: 'Invalid Address Id',
    },
    CUSTOMER_NOT_FOUND: {
      label: 'Customer not found',
    },
    DUPLICATE_ADDRESS_CODE: {
      label: 'Duplicated Address code',
    },
    DUPLICATE_ADDRESS_ID: {
      label: 'Duplicated Address #',
    },
    MISSING_ADDRESS_CODE: {
      label: 'Missing Address Code',
    },
    MISSING_ADDRESS_1: {
      label: 'Missing Address 1',
    },
    MISSING_ADDRESS_2: {
      label: 'Missing Address 2',
    },
    MISSING_COUNTRY: {
      label: 'Missing Country',
    },
    MISSING_REQUIRED_ADDITIONAL_FIELD: {
      label: 'Missing Required Additional Field',
    },
    MISSING_PHONEX_CUSTOMER_NUMBER: {
      label: 'Missing Phonex Customer #',
    },
    MISSING_REF_CUSTOMER_NUMBER: {
      label: 'Missing Ref Customer #',
    },
    INVALID_ADDRESS_TYPE_SELECTION: {
      label: 'Address can only be Default Billing/Shipping if it is Billing/shipping address',
    },
    FIELD_EXCEEDS_LENGTH: {
      label: 'Address Fields exceed Length',
    },
  },
  addressImportWarning: {
    ADDRESS_MARKED_INACTIVE: {
      label: 'Address will be marked as inactive',
    },
    ADDRESS_TYPE_NOT_SET: {
      label: 'Address type not set',
    },
  },
  addressImportUpdate: {
    UPDATED: {
      label: 'Updated',
    },
    NEW: {
      label: 'New Address',
    },
  },

  userImportError: {
    label: 'Errors found (will be skipped)',
    DUPLICATE_EMAIL: {
      label: 'Duplicate User email',
    },
    DUPLICATE_USER_NUMBER: {
      label: 'Duplicate User Number',
    },
    MISSING_EMAIL: {
      label: 'Missing User Email',
    },
    MISSING_FIRST_NAME: {
      label: 'Missing First Name',
    },
    MISSING_ROLE: {
      label: 'Missing Role',
    },
    MISSING_LAST_NAME: {
      label: 'Missing Last Name',
    },
    MISSING_REQUIRED_ADDITIONAL_FIELD: {
      label: 'Missing a Required Additional Field',
    },
    MISSING_PHONEX_CUSTOMER_NUMBER: {
      label: 'Missing Phonex Customer #',
    },
    MISSING_REF_CUSTOMER_NUMBER: {
      label: 'Missing Ref Customer #',
    },
    CUSTOMER_NOT_FOUND: {
      label: 'Missing Customer',
    },
    USER_NOT_FOUND: {
      label: 'Missing User',
    },
    INVALID_EMAIL: {
      label: 'Invalid User Email',
    },
    INVALID_ROLE: {
      label: 'Invalid User Role',
    },
    INVALID_FIELD_VALUE: {
      label: 'Invalid Field Value',
    },
    INVALID_STATUS: {
      label: 'Invalid Status',
    },
    FIELD_EXCEEDS_LENGTH: {
      label: 'Field Exceeds length',
    },
    USERNAME_ALREADY_EXISTS: {
      label: 'Username Already Exists',
    },
  },
  userImportWarning: {
    STATUS_CHANGE: {
      label: 'Status Changed',
    },
    USER_DEACTIVATED: {
      label: 'Users Changed to Deactivated',
    },
    USER_ACTIVATED: {
      label: 'Users Changed to Active',
    },
    INVALID_ROLE: {
      label: 'Role will be Purchaser for new users and unchanged for existing users',
    },
    INVALID_STATUS: {
      label: 'Status will be default for new users and unchanged for existing users',
    },
  },
  userImportUpdate: {
    UPDATED: {
      label: 'Users with Changes',
    },
    NEW: {
      label: 'New Users Added',
    },
    CUSTOMER_WITH_USER_CHANGES: {
      label: 'Customers with User Changes',
    },
  },
};

export const logOutTheUser = async (message: string, severity: any, messageType?: any) => {
  try {
    await Auth.signOut();
    localStorage.clear();
    window.indexedDB.deleteDatabase('d2');
    localStorage.setItem(
      'customLoginLoadMessage',
      JSON.stringify({ message, severity, messageType })
    );
    document.location.href = '/';
  } catch (error: any) {
    console.error('error signing out: ', error);
  }
};

export const tableColWidth: any = {
  order: {
    buyerId: {
      minWidth: 200,
    },
    createDate: {
      minWidth: 100,
    },
    updateDate: {
      minWidth: 100,
    },
    warehouseCode: {
      minWidth: 90,
    },
    // daysOnhold: 30,
    fulfillmentStatus: 180,
    // margin: 20,
    // marginPercent: 20,
    // orderTotal: 20,
    paymentStatus: 166,
    phonexOrderNumber: {
      minWidth: 140,
    },
    refOrderNumber: {
      minWidth: 140,
    },
    // updateDate: 20,
    // warehouseCode: 20,
  },
};

export const getDateFormat = (date: string): string => {
  // find the format
  const dateFormatsSupported = [
    'Mo-dd-yyyy',
    'MM-dd-yyyy',
    'MMM-dd-yyyy',
    'MMMM-dd-yyyy',
    'MMMMM-dd-yyyy',
    'Mo/dd/yyyy',
    'MM/dd/yyyy',
    'MMM/dd/yyyy',
    'MMMM/dd/yyyy',
    'MMMMM/dd/yyyy',
    'Mo dd yyyy',
    'MM dd yyyy',
    'MMM dd yyyy',
    'MMMM dd yyyy',
    'MMMMM dd yyyy',
    'Mo.dd.yyyy',
    'MM.dd.yyyy',
    'MMM.dd.yyyy',
    'MMMM.dd.yyyy',
    'MMMMM.dd.yyyy',
    'MM/dd',
    'MM.dd',
    'MM dd',
    'MMMM/dd',
    'MMMM.dd',
    'MMMM dd',

    'yyyy-dd-Mo',
    'yyyy-dd-MM',
    'yyyy-dd-MMM',
    'yyyy-dd-MMMM',
    'yyyy-dd-MMMMM',
    'yyyy/dd/Mo',
    'yyyy/dd/MM',
    'yyyy/dd/MMM',
    'yyyy/dd/MMMM',
    'yyyy/dd/MMMMM',
    'yyyy dd Mo',
    'yyyy dd MM',
    'yyyy dd MMM',
    'yyyy dd MMMM',
    'yyyy dd MMMMM',
    'yyyy.dd.Mo',
    'yyyy.dd.MM',
    'yyyy.dd.MMM',
    'yyyy.dd.MMMM',
    'yyyy.dd.MMMMM',

    'dd-Mo-yyyy',
    'dd-MM-yyyy',
    'dd-MMM-yyyy',
    'dd-MMMM-yyyy',
    'dd-MMMMM-yyyy',
    'dd/Mo/yyyy',
    'dd/MM/yyyy',
    'dd/MMM/yyyy',
    'dd/MMMM/yyyy',
    'dd/MMMMM/yyyy',
    'dd Mo yyyy',
    'dd MM yyyy',
    'dd MMM yyyy',
    'dd MMMM yyyy',
    'dd MMMMM yyyy',
    'dd.Mo.yyyy',
    'dd.MM.yyyy',
    'dd.MMM.yyyy',
    'dd.MMMM.yyyy',
    'dd.MMMMM.yyyy',
    'dd/MMMM',
    'dd.MMMM',
    'dd MMMM',
  ];

  for (let i = 0; i < dateFormatsSupported.length; i++) {
    const parsedDate = parse(date, dateFormatsSupported[i], new Date());
    if (isValid(parsedDate)) {
      return dateFormatsSupported[i];
    }
  }
  return '';
};

export const formatISODate = (date: string) => {
  return date
    .split(' ')
    .filter((_: any, idx: number) => {
      return idx < 4;
    })
    .join(' ');
};

export const toCamelCase = (str: string) => {
  return str
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/\W+/g, ' ')
    .replace(/ (.)/g, function ($1) {
      return $1.toUpperCase();
    })
    .replace(/ /g, '');
};

export const generateAddressParts = (state: string, nextState: string) => {
  return state ? state + (nextState ? ', ' : '') : '';
};

export const checkNullOrUndefined = (val: any) => {
  return val === null || val === undefined;
};

export type DataFormattingType =
  | 'id'
  | 'date'
  | 'percent'
  | 'currency'
  | 'currency-with-no-0'
  | 'integer'
  | 'days'
  | 'string'
  | 'number'
  | 'days-hours-mins'
  | 'hours'
  | 'dateInEST'
  | 'dateInESTWithTime';

export const dataFormatting = (
  type: DataFormattingType,
  value: any,
  isZeroShownForCurrency?: boolean
) => {
  if (specialFilters[value]) value = specialFilters[value];
  switch (type) {
    case 'id':
      return value || value === 0 ? `${value}` : '--';
    case 'date':
      return dateFormatting(value);
    case 'percent':
      return percentFormatting(value);
    case 'currency':
      return currencyFormatter(value, 2, isZeroShownForCurrency);
    case 'currency-with-no-0':
      return currencyFormatter(value, 0, isZeroShownForCurrency);
    case 'integer':
      return integerFormatting(value);
    case 'number':
      return value
        ? value.toLocaleString('en', { useGrouping: true, minimumFractionDigits: 2 })
        : '--';
    case 'days':
      return daysFormatting(value);
    case 'days-hours-mins':
      return daysToHoursMinuteFormatting(value);
    case 'dateInEST':
      return dateFormattingInEST(value)
    case 'hours':
      return hoursToDateFormatting(value);
    case 'dateInESTWithTime':
      return dateFormattingInESTWithTime(value)
    default:
      return value ? specialSymbols[value] || value : '--';
  }
};
const daysToHoursMinuteFormatting = (value: any) => {
  if (checkNullOrUndefined(value)) return '--';
  if (typeof value === 'number') {
    const days = Math.trunc(value);
    const hoursMinFraction = (value - days) * 24;
    const hrs = Math.trunc(hoursMinFraction);
    const mins = Math.trunc((hoursMinFraction - hrs) * 60);
    if (!days && !hrs && !value) {
      return '0h 0m';
    }
    return days ? `${days}d ${hrs}h` : `${hrs}h ${mins}m`;
  }
};

const hoursToDateFormatting = (value :any) => {
  if (checkNullOrUndefined(value)) return '--';
  if (typeof value === 'number') {
    const days = Math.floor(value / 24);
    const hrs = Math.floor(value) % 24;
    if (!days && !hrs && !value) {
      return '0h 0m';
    }
    return days ? `${days}d ${hrs}h` : `${hrs}h`;
  }
}

const dateFormatting = (value: any) => {
  return value ? formatISODate(parseISO(value).toString()).slice(3) : '--';
};

const dateFormattingInEST = (value: any) => {

  try{
    if(value){
      const date = changeTimeZone(new Date(value),'America/New_York')
      return format(date, 'MMM dd yyyy')
    }
    return '--'
  }catch(e){
    console.log(e)
    return '--'
  }
}
export const changeTimeZone = (date: Date, timeZone: string= 'America/New_York') => {
  return new Date(
    date.toLocaleString('en-US', {
      timeZone,
    }),
  );
}
const percentFormatting = (value: any) => {
  if (value === Infinity) return specialSymbols[value];
  return +value ? `${(+value).toFixed(1)}%` : value && value !== 'NaN' ? value : '--';
};

const integerFormatting = (value: any) => {
  return `${
    value ? value.toLocaleString('en', { useGrouping: true, minimumFractionDigits: 0 }) : '--'
  }`;
};

const daysFormatting = (value: any) => {
  if (checkNullOrUndefined(value)) return '--';
  if (typeof value === 'number') {
    // const daysHrsArr = `${value}`.split('.');
    const days = Math.trunc(value);
    const hoursMinFraction = (value - days) * 24;
    const hrs = Math.trunc(hoursMinFraction);
    // const min = Math.trunc((hoursMinFraction - hrs) * 60);
    if (!days && !hrs && !value) {
      return 'Just now';
    }
    return `${days}d ${hrs}h`;
  }

  const diffDate = intervalToDuration({
    start: new Date(value),
    end: new Date(),
  });

  if (
    !diffDate ||
    (!diffDate?.years &&
      !diffDate?.months &&
      !diffDate?.days &&
      !diffDate?.hours &&
      !diffDate?.minutes)
  ) {
    return 'Just now';
  }

  return `${diffDate.days ? `${diffDate.days}d` : ''}${
    diffDate.hours ? ` ${diffDate.hours}h ` : ''
  }${diffDate.minutes ? ` ${diffDate.minutes}m ` : ''}`;
};

export const currencyFormatter = (value: any, minimumFractionDigits: number, isZeroShown?: boolean, currency?:string) => {
  if ((!isZeroShown || (isZeroShown && value !== 0)) && !value) return '--';
  if (value === Infinity) return specialSymbols[value];
  const localeCurrency = currency || localStorage.getItem('PxCurrencySymbol');
  let currencySymbol = '$';
  if (localeCurrency) {
    currencySymbol = localeCurrency;
  }

  if (typeof value === 'string') {
    return `${currencySymbol}${value}`;
  }
  const val = +(+value).toFixed(2);
  return val >= 0
    ? `${currencySymbol}${val.toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits,
      })}`
    : `-${currencySymbol}${Math.abs(val).toLocaleString('en', {
        useGrouping: true,
        minimumFractionDigits,
      })}`;
};

export const specialSymbols: any = {
  [Infinity]: '∞',
};

export const formatBuyerName = (buyerName: string) => {
  return buyerName?.substr(0, 32) + (buyerName.length > 32 ? '...' : '');
};

export const createDateFilterLabel = (startDateStr: string, endDateStr: string) => {
  try {
    let label = '';
    const startDate = new Date(startDateStr),
      endDate = new Date(endDateStr),
      dateDiff = differenceInCalendarDays(endDate, startDate);
    if (isToday(endDate)) {
      switch (dateDiff) {
        case 7:
          label = 'Last 7 Days';
          break;
        case 14:
          label = 'Last 14 Days';
          break;
        case 28:
          label = 'Last 28 Days';
          break;
        default:
          label = `${format(startDate || 0, 'MMM dd')} -  ${format(endDate || 0, 'MMM dd')}`;
          break;
      }
    } else {
      label = `${format(startDate || 0, 'MMM dd')} -  ${format(endDate || 0, 'MMM dd')}`;
    }

    if (dateDiff < 0) label = 'Infinity';
    return label;
  } catch (error) {
    console.log('error while parsing the filter date', error);

    return 'Infinity';
  }
};

// >> Data filtering >>

const specialFilters: any = {
  orders: {
    multipleSearch: true,
    multipleSearchCol: 'phonexOrderNumber',
    multipleSearchPrefix: 'Order',
    multipleSearchRegex: '({prefix}[0-9]+[\\s]*)+', // PXSTKL0000232 PXSTKL0000231 PXSTKL0000230
    phonexOrderNumber: 'string',
    createDate: 'date',
    paymentStatus: 'label',
    fulfillmentStatus: 'label',
    refOrderNumber: 'string',
    updateDate: 'date',
    buyerId: 'label',
    orderTotal: 'currency',
  },
  ordersAdd: {
    multipleSearch: true,
    multipleSearchCol: 'itemNumber',
    multipleSearchPrefix: 'SKU',
    multipleSearchRegex: /^[0-9|\s]+$/, // 1011767 1011849
    description: 'string',
    category: 'string',
    listPrice: 'currency',
    lowPrice: 'currency',
  },
  offerClearing: {
    multipleSearch: true,
    multipleSearchCol: 'itemNumber',
    multipleSearchPrefix: 'SKU',
    multipleSearchRegex: /^[0-9|\s]+$/,
    stocklistDescription: 'generated',
    stocklistRowDescription: 'generated',
  },
  pricing: {
    multipleSearch: true,
    multipleSearchCol: 'itemNumber',
    multipleSearchPrefix: 'SKU',
    multipleSearchRegex: /^[0-9|\s]+$/,
    stocklistDescription: 'generated',
    stocklistRowDescription: 'generated',
  },
  channel: {
    multipleSearch: true,
    multipleSearchCol: 'itemNumber',
    multipleSearchPrefix: 'SKU',
    multipleSearchRegex: /^[0-9|\s]+$/,
    description: 'string',
    itemNumber: 'string',
    itemNumberWarehouse: 'string',
    lastUpdatedDate: 'date',
    channel: 'string',
    warehouse: 'label',
    category: 'string',
    defaultChannel: 'generated',
  },
  inventory: {
    multipleSearch: true,
    multipleSearchCol: 'itemNumber',
    multipleSearchPrefix: 'SKU',
    multipleSearchRegex: /^[0-9|\s]+$/,
    description: 'string',
    itemNumber: 'string',
    itemNumberWarehouse: 'string',
    lastUpdatedDate: 'date',
    channel: 'label',
    warehouse: 'string',
    warehouseLabel: 'string',
    category: 'string',
  },
  customer: {
    buyerName: 'string',
    buyerNumber: 'string',
    country: 'string',
    createDate: 'date',
    email: 'string',
    id: 'string',
    active: 'label',
    phone: 'string',
    registrationStatus: 'label',
    salesRepEmail: 'exactString',
    salesRepName: 'string',
    state: 'string',
    // totalActiveUsers: 'string',
    // totalInactiveUsers: 'string',
    updateDate: 'date',
    users: 'array',
    whatsApp: 'string',
  },
  clients:{
    clientName: 'string',
    status: 'string',
    officialLegalName:'string',
    awaitingPayment: 'currency',
    hoursAwaitingPayment: 'number',
    tenantSignedDate: 'date',
    freeTrialEnd: 'date',
    endDate: 'date',
    billingCountry: 'string',
    billingState: 'string',
    currency: 'string',
    currencyCode:'string'
  }, 
  invoice: {
    // multipleSearch: true,
    // multipleSearchCol: 'invoiceNumber',
    // multipleSearchPrefix: 'INVOICE',
    invoiceNumber: 'string',
    client: 'string',
    invoiceDate: 'date',
    invoicedAmount: 'currency',
    invoiceStatus: 'string',
    cardPaymentStatus: 'string',
    amountOwed: 'currency',
    dueDate: 'date',
    billingPeriodStartDate: 'date',
    billingPeriodEndDate: 'date',
    billingPeriodOrders: 'currency',
    billingPeriodOrdersInUsd: 'currency',
    referrer: 'string',
  },
  clientForms:{
    clientName: 'string',
    companyName: 'string',
    contactEmail: 'string',
    createDate: 'date',
    // status: 'string',
    updateDate: 'date'
  }
};

export const generateLabelKey = (fieldName: string) => {
  return `${fieldName}Labels`;
};

// sanitize
// eslint-disable-next-line no-useless-escape
const illegalRe = /[\/\?<>\\:\*\|":®©℗]/g;
// eslint-disable-next-line no-control-regex
const controlRe = /[\x00-\x1f\x80-\x9f]/g;

export function sanitize(input: string, replacement: string = '_') {
  const sanitized = input.replace(illegalRe, replacement).replace(controlRe, replacement);
  return sanitized;
}

// << Data filtering <<

export const getI18n = () => {
  return new Promise((resolve: any) => {
    localStorage.setItem('PxI18n', JSON.stringify(i18n));
    localStorage.setItem('Px-localeFromConfig', lang);
    resolve(i18n);
  //   const getI18nByLang = (data: any) => {
  //     const localeFromConfig = localStorage.getItem('Px-localeFromConfig');
  //     const browserLocale = navigator.languages ? navigator.languages : [navigator.language];
  //     let chosenLocale: any = null;
  //     if (localeFromConfig && data.hasOwnProperty(localeFromConfig)) {
  //       // If user chose a locale from config, use it
  //       chosenLocale = localeFromConfig;
  //     } else {
  //       // Or try using the locale from browser
  //       Object.keys(data).forEach((i18nLang: string) => {
  //         if (!chosenLocale) {
  //           browserLocale.forEach((l: string) => {
  //             if (!chosenLocale && i18nLang.indexOf(l) > -1) {
  //               chosenLocale = i18nLang;
  //             }
  //           });
  //         }
  //       });
  //     }
  //     const localI18n: any = localStorage.getItem('PxConfig');
  //     chosenLocale = JSON.parse(localI18n)?.language;
  //     console.log('chosenLocale ' + chosenLocale);
  //     if (chosenLocale && !localeFromConfig) {
  //       localStorage.setItem('Px-localeFromConfig', chosenLocale);
  //     }

  //     const currencySymbol = localStorage.getItem('PxCurrencySymbol');
  //     if (!currencySymbol && data[chosenLocale]?.currency?.i18n_value) {
  //       localStorage.setItem('PxCurrencySymbol', data[chosenLocale]?.currency?.i18n_value);
  //     }
  //     if (chosenLocale) {
  //       document.documentElement.lang = chosenLocale;
  //       return data[chosenLocale];
  //     }
  //     return {};
  //   };

  //   // Try loading i18n from localStorage
  //   const localI18n = localStorage.getItem('PxI18n');
  //   if (localI18n) {
  //     const i18n = getI18nByLang(JSON.parse(localI18n));
  //     resolve(i18n);
  //   } else {
  //     console.log('rocess.env.REACT_APP_STAGE ' + process.env.REACT_APP_STAGE);
  //     let publicDataEndpoint =
  //       'https://l2dqqbs9r2.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-i18n';
  //     if (process.env.REACT_APP_STAGE === 'test') {
  //       publicDataEndpoint =
  //         'https://s4z4motqq3.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-i18n';
  //     } else if (process.env.REACT_APP_STAGE === 'prod') {
  //       publicDataEndpoint =
  //         'https://qkexusfqqf.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-i18n';
  //     } else if (process.env.REACT_APP_STAGE === 'release') {
  //       publicDataEndpoint =
  //         'https://94o107xk88.execute-api.us-east-1.amazonaws.com/Integration/px-api-gateway/saas-i18n';
  //     }
  //     axios.get(publicDataEndpoint).then(async (res: any) => {
  //       if (res.data.status === 200) {
  //         const remoteI18n = Object.assign({}, res.data.results);
  //         let i18n: any = {};
  //         if (Object.keys(remoteI18n).length) {
  //           // Only store i18n if it had content
  //           localStorage.setItem('PxI18n', JSON.stringify(remoteI18n));
  //           i18n = getI18nByLang(remoteI18n);
  //         }
  //         resolve(i18n);
  //       } else {
  //         resolve({});
  //       }
  //     });
  //   }
  });
};

export const getWorkflowStatus = async (tenant_id: string) => {
    return await commonService('post', `/workflow/status`, {
      body: { "tenant_id": tenant_id },
      responseType: 'text',
    });
};

export const startWorkflow = async (body: any, logoState?: any, favicon?:any) => {
  const formData:any = new FormData();
  if(logoState) formData.append('user_pool_logo', logoState);
  if(favicon) formData.append('favicon', favicon);
  Object.keys(body).forEach((key: string) => {
    if (typeof body[key] === 'boolean' || (!!body[key] && body[key].length))
      formData.append(key, body[key]);
  });
  return await commonService('post', `/workflow/start`, {
    body: formData,
    headers: { 'Content-Type': 'multipart/form-data', },
    responseType: 'text'
  });
};

export const resumeWorkflow = async (tenant_id: string) => {
    return await commonService('post', `/workflow/resume`, {
      body: { "tenant_id": tenant_id },
      responseType: 'text',
    });
};

export const downloadTemplateXlsx = async () => {
    return await commonService('get', `/settings-excel/excel-template`, {
      responseType: 'text',
    });
};

export const downloadXlsxTenant = async (tenant_id: string) => {
    return await commonService('get', `/settings-excel/tenant-settings`, {
      headers: { "tenant_id": tenant_id },
      responseType: 'text',
    });
};

export const tenantConfigPreview = async (tenant_id: string, fileState: any) => {
    const formData = new FormData();
    formData.append('file', fileState);
    return await commonService('post', `/settings-excel/preview`, {
      headers: {
        "tenant_id": tenant_id,
        'Content-Type': 'multipart/form-data',
      },
      body: formData,
      responseType: 'text',
    });
};

export const tenantConfigSubmit = async (tenant_id: string, fileState: any) => {
    const formData = new FormData();
    formData.append('file', fileState);
    return await commonService('post', `/settings-excel/submit`, {
      headers: { 
        "tenant_id": tenant_id,
        'Content-Type': 'multipart/form-data',
      },
      body: formData,
      responseType: 'text',
    });
};
const tenantApiEndPoint = process.env.REACT_APP_ADMIN_API || 'https://7aw3yxmw73.execute-api.us-east-1.amazonaws.com/Integration'

export const fetchData  = async (
  method: string,
  url: string,
  params?: any,
  isFileUpload?:boolean,
  baseUrl?:string
) => {
  let headers: any;
  let body: any;
  if (params?.header) {
    headers = params.header;
  }
  if (params.body) {
    body = params.body;
  }
if(!isFileUpload){
  body = JSON.stringify(body)
}
  let res: any;
  try {
    res = await fetch(`${baseUrl?baseUrl:tenantApiEndPoint}/${url}`, {
      method,
      body,
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
        ...headers,
      },
    });
    let finalResponse={}
    if(res.status !== 200){
      let response = await res.json();
      finalResponse ={error: true,...response}
    }else{
      finalResponse = await res.json();
    }
    return finalResponse;
    
  } catch (err: any) {
    console.log(err.message);
    return  {error: true,message:err.message}
  }
};
interface IConstructLabel {
  fieldName: any;
  settings: any;
  id?: any;
}

const constructLabel = ({ fieldName, settings, id = '' }: IConstructLabel) => {
  const label = generateLabelKey(fieldName);
  const labelValid = settings[label] && settings[label][id];
  let returnLabel = labelValid ? settings[label][id] : fieldName;
  if (fieldName === 'buyerId') {
    returnLabel = returnLabel.buyerName;
  }
  return returnLabel;
};
interface ISearchEngine {
  searchTerm: string;
  pieces?: Array<string>;
  item?: any;
  view: string;
  settings: any;
}
const searchEngine = ({ searchTerm, pieces, item, view, settings }: ISearchEngine): boolean => {
  let res: boolean = false;
  if (Array.isArray(pieces) && pieces.length) {
    // search SKUs
    return pieces.includes(item[specialFilters[view].multipleSearchCol]);
  } else {
    // search Term
    if (specialFilters[view]) {
      Object.keys(specialFilters[view]).forEach((val) => {
        if (
          res ||
          (!item[val] && specialFilters[view][val] !== 'generated') ||
          val.includes('multiple')
        ) {
          return;
        }
        try {
          // only support single nested items => must be an array
          if (val.includes('.')) {
          }
          let searchStr = '';
          // look for types
          switch (specialFilters[view][val]) {
            case 'string':
              searchStr =
                val === 'description' ? removeTwoSimultaneousSpaces(item[val]) : `${item[val]}`;
              break;
            case 'date':
              searchStr = dataFormatting('date', item[val]);
              res = searchStr.includes(dataFormatting('date', new Date(searchTerm).toISOString()));
              return;
            case 'label':
              searchStr = constructLabel({
                fieldName: val,
                id: item[val],
                settings: settings,
              });
              break;
            case 'currency':
              searchStr = dataFormatting('currency', item[val]);
              break;
            // case 'generated':
            //   searchStr = generateConstructedLabel({ specialFilterName: val, item, settings });
            //   break;
            case 'number':
              break;
            case 'array':
              searchStr = item[val].map((itemVal: string) => {
                return itemVal.toLowerCase();
              });
              break;
            case 'exactString':
              searchStr = item[val];
              break;
            default:
              break;
          }

          switch (specialFilters[view][val]) {
            case 'array':
              res = searchStr.includes(searchTerm);
              break;
            case 'exactString':
              res = searchStr === searchTerm;
              break;
            default:
              res = searchStr.toLowerCase().trim().includes(searchTerm);
              break;
          }

        } catch (error: any) {
          // console.log('unable to search through: ', val, 'error:', error.message);
        }
      });
    }
  }
  return res;
};

const getUpdatedFilterCount = (currentCount: number | undefined, incrementBy1: boolean) => {
  return (currentCount || 0) + (incrementBy1 ? 1 : 0);
};

export const removeTwoSimultaneousSpaces = (data: string): string => {
  let newStr = '';
  for (let index = 0; index < data.length; index++) {
    if (data[index] === ' ' && data[index + 1] === ' ') {
      index++;
    }
    newStr += data[index];
  }

  return newStr;
};

export const advanceFilterEngine: IAdvanceFilterEngine = ({
  advanceFilters = {},
  searchTermState,
  filtersApplied,
  outOfStockField,
  itemsList,
  settings,
  view,
}) => {
  return new Promise((res) => {
    if (!Array.isArray(itemsList)) itemsList = [];
    // getting chips in use [category, outOfStocks, new]
    const filterAttr: Array<keyof IFiltersApplied> = Object.keys(filtersApplied);
    // results
    const results: IAdvanceFilterEngineRes = {
      items: [],
      filterCounts: {
        absolute: {
          buyerFilter: {},
        },
        filtered: {
          buyerFilter: {},
        },
        searchedAbsolute: {
          buyerFilter: {},
        },
        includeOutOfStock: filtersApplied.outOfStock,
        itemSearched: 0,
      },
      itemProperties: [], // List of properties from DB table
      tabStats: {}, // hold the tab stats of the
    };

    let pieces: any = null;
    let searchTerm: string = searchTermState || '';

    // checking if the search term starts with Item #

    if (
      searchTerm?.length &&
      specialFilters[view] &&
      specialFilters[view]?.multipleSearch &&
      searchTerm.match(new RegExp(`^(${specialFilters[view].multipleSearchPrefix})[:]*`, 'i'))
    ) {
      searchTerm = searchTerm.split(':')[1].trim();
    }

    if (searchTerm?.length && specialFilters[view]?.multipleSearch) {
      if (
        (view === 'orders' || view === 'reachOrders') &&
        !!searchTerm.match(
          new RegExp(
            formatString(specialFilters[view].multipleSearchRegex, {
              prefix: 'PXSTKL',
            }),
            'i'
          )
        )
      ) {
        pieces = searchTerm
          .trim()
          .split(' ')
          .map((val) => {
            return val.trim();
          });
      } else if (!!searchTerm.match(new RegExp(specialFilters[view]?.multipleSearchRegex))) {
        // dividing search term
        // TODO: - Make / dynamic to come from config
        pieces = removeTwoSimultaneousSpaces(searchTerm.trim())
          .split(' ')
          .map((val) => {
            return val.trim();
          });
      }
    }

    // set of all array keys
    const offersKeySet = new Set<string>();
    // all the items
    itemsList.forEach((item: any) => {
      if (results.itemProperties.length <= Object.keys(item).length) {
        const itemProps = new Set([...Object.keys(item), ...results.itemProperties]);
        results.itemProperties = Array.from(itemProps);
      }
      // is a match for the search term
      let matchSearchTerm = !searchTerm || !searchTerm.length ? true : false;

      if (searchTerm) {
        matchSearchTerm = searchEngine({
          searchTerm: searchTerm.trim().toLowerCase(),
          view,
          pieces,
          item,
          settings,
        });
      }
      // item match to chip filters currently selected
      let itemMatchChips = false;
      // only validate if the current item satisfy search criteria
      if (matchSearchTerm) {
        itemMatchChips = true;
        const count = filterAttr.length;
        for (let i = 0; i < count; i++) {
          const chipName: keyof IFiltersApplied = filterAttr[i];
          // if chipName is out of stock, can be changed dynamically
          if (chipName === 'outOfStock') {
            if (filtersApplied['outOfStock'] && item[outOfStockField] > 0) {
              itemMatchChips = true;
            } else if (!filtersApplied['outOfStock'] && item[outOfStockField] <= 0) {
              itemMatchChips = false;
            }
          } else {
            // priortize the advance or custom filters
            if (advanceFilters.hasOwnProperty(chipName)) {
              itemMatchChips = advanceFilters[chipName](item, filtersApplied);
            } else {
              // check for the predefined chip as buyer filter
              // TODO: pre defined filters
              const fieldData = item[chipName] || '(Blanks)';
              if (
                typeof filtersApplied[chipName] !== 'boolean' &&
                (!filtersApplied[chipName] || !filtersApplied[chipName][fieldData])
              ) {
                itemMatchChips = false;
              }
            }
          }
          if (!itemMatchChips) {
            break;
          }
        }
      }

      // If item survives filtering, add it to final list
      if (matchSearchTerm && itemMatchChips) {
        // check the tab category of the item
        // if (view) {
        //   const tabCatVal = getTabValue(view, item);
        //   tabCatVal.forEach((tabCat) => {
        //     results.tabStats[tabCat] = results.tabStats[tabCat] ? results.tabStats[tabCat] + 1 : 1;
        //   });
        // }
        results.items.push({ ...item });
      }

      // Get counts for Menu
      results.itemProperties.forEach((key: string) => {
        let fieldName = item[key] || '(Blanks)';
        // setting offers filter
        if (key === 'offers') {
          // document unique buyer ids
          // menu contains all the unique values, ßmenu filter contains counts of the
          item[key].forEach((obj: any) => {
            const buyerId = obj.buyerId;
            results.filterCounts.absolute.buyerFilter[buyerId] = getUpdatedFilterCount(
              results.filterCounts.absolute.buyerFilter[buyerId],
              true
            );
            results.filterCounts.filtered.buyerFilter[buyerId] = getUpdatedFilterCount(
              results.filterCounts.filtered.buyerFilter[buyerId],
              matchSearchTerm && itemMatchChips
            );
            results.filterCounts.searchedAbsolute.buyerFilter[buyerId] = getUpdatedFilterCount(
              results.filterCounts.searchedAbsolute.buyerFilter[buyerId],
              matchSearchTerm
            );
          });
        } else {
          // if (checkNullOrUndefined(item[key]) || item[key] === '') return;
          if (!results.filterCounts.filtered[key]) {
            results.filterCounts.absolute[key] = {};
            results.filterCounts.filtered[key] = {};
            results.filterCounts.searchedAbsolute[key] = {};
          }
          results.filterCounts.absolute[key][fieldName] = getUpdatedFilterCount(
            results.filterCounts.absolute[key][fieldName],
            true
          );
          results.filterCounts.filtered[key][fieldName] = getUpdatedFilterCount(
            results.filterCounts.filtered[key][fieldName],
            matchSearchTerm && itemMatchChips
          );
          results.filterCounts.searchedAbsolute[key][fieldName] = getUpdatedFilterCount(
            results.filterCounts.searchedAbsolute[key][fieldName],
            matchSearchTerm
          );
        }
      });
    });
    // push array key set into item properties
    if (offersKeySet.size > 0) {
      results.itemProperties.push(...Array.from(offersKeySet));
    }

    if (results?.filterCounts.filtered) {
      // Clear zero results
      Object.keys(results.filterCounts.filtered).forEach((k: string) => {
        const tmp: any = {};
        for (let prop in results.filterCounts.filtered[k]) {
          if (results.filterCounts.filtered[k][prop] > 0) {
            tmp[prop] = results.filterCounts.filtered[k][prop];
          }
        }
        results.filterCounts.filtered[k] = { ...tmp };
      });
    }

    if (pieces?.length) {
      results.searchTerm = `${specialFilters[view].multipleSearchPrefix}: ${searchTerm}`;
    }
    res(results);
  });
};

export const trimValue = (obj: any) =>{
  const trimedObj = {...obj}
  Object.keys(trimedObj).map((key: string)=> trimedObj[key] = trimedObj[key] && typeof trimedObj[key] === 'string' ? trimedObj[key].trim() : trimedObj[key]);
  return trimedObj;
}

export const previewPdf = async (file: any, fileName?: string) => {
  const blob = new Blob([file.data], { type: 'application/pdf' });
  const fileURL = window.URL.createObjectURL(blob);
  window.open(fileURL, '_blank');
};

const dateFormattingInESTWithTime = (value: any) => {

  try{
    if(value){
      const date = changeTimeZone(new Date(value),'America/New_York')
      return format(date, 'MMM dd, yyy, hh:mm aaa')
    }
    return '--'
  }catch(e){
    console.log(e)
    return '--'
  }
}